<app-ion-common-header [id]="headerId" (backHeader)="back()" [title]="titlePage">
</app-ion-common-header>

<ion-content>
    <app-ion-common-label class="document-type-label1" labelStyle="display-rg"
        labelDescription="Ops! Desculpe-nos. Estamos melhorando nossos serviços. Tente novamente mais tarde.">
    </app-ion-common-label>
</ion-content>